import { useContext } from 'react';

import { BiLoggerContext } from './bi-logger-context-provider';

export const useBiLogger = () => {
  return useContext(BiLoggerContext);
};
